import Lottie from 'lottie-react'
import React from 'react'

import Loader from '../assets/animations/loader.json'

const mainDivStyles = {
  backgroundColor: 'black',
  opacity: 0.6,
  width: '100%',
  height: '100%',
  display: 'flex',
  position: 'fixed',
  zIndex: 9999999,
  justifyContent: 'center',
  alignItems: 'center',
}

const ActivityIndicator = ({ visible, componentLoader = false }) => {
  if (!visible) return null

  return (
    <div
      className='d-flex justify-content-center'
      style={componentLoader ? null : mainDivStyles}
    >
      <Lottie
        style={{ width: '300px', height: '300px' }}
        animationData={Loader}
        autoPlay
        loop
      />
    </div>
  )
}

export default ActivityIndicator
